import {
  TSnackbarReadoutValue,
  TUrl,
} from "@ecp-redux/dto/themeSettings/themeSettings.types";
import { PathStringType } from "../shared/portalPath/portalPath";
import {
  IAddToWishlistSetting,
  IComparisonSetting,
} from "./contentPatterns.scheme";

export type TTextContent = string;

interface IGoToPage {
  selectedGoToOption: SelectedGoToOption.GO_TO_PAGE;
  goToPageSetting: IGoToPageSetting;
  showLinkOptions?: boolean;
  goToRowSetting?: IGoToRowSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  addToWishlistSetting?: IAddToWishlistSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
}

interface IGoToRow {
  selectedGoToOption: SelectedGoToOption.GO_TO_ROW;
  goToRowSetting: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
}

interface IChangeOrderInsideStack {
  selectedGoToOption: SelectedGoToOption.CHANGE_ORDER_INSIDE_STACK;
  goToPageSetting?: IGoToPageSetting;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  forceOrderInsideStack: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
}

interface IOpenPopup {
  selectedGoToOption: SelectedGoToOption.OPEN_POPUP;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  closePopupSetting?: IClosePopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
  openPopupSetting: IOpenPopupSetting;
}

interface IClosePopup {
  selectedGoToOption: SelectedGoToOption.CLOSE_POPUP;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
  closePopupSetting: IClosePopupSetting;
}

interface IComparison {
  selectedGoToOption: SelectedGoToOption.COMPARISON;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
  comparisonSetting: IComparisonSetting;
}

interface IAddToWishlist {
  selectedGoToOption: SelectedGoToOption.ADD_TO_WISHLIST;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting?: IEndpointActionSetting;
  addToWishlistSetting: IAddToWishlistSetting;
}

interface IPopupAction {
  selectedGoToOption: SelectedGoToOption.POPUP_ACTION;
  goToRowSetting?: IGoToRowSetting;
  showLinkOptions?: boolean;
  goToPageSetting?: IGoToPageSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  addToWishlistSetting?: IAddToWishlistSetting;
  endpointActionSetting?: IEndpointActionSetting;
  actionPopupSetting: PopupActionsList;
}

interface IEndpointAction {
  selectedGoToOption: SelectedGoToOption.ENDPOINT_ACTION;
  goToPageSetting?: IGoToPageSetting;
  showLinkOptions?: boolean;
  goToRowSetting?: IGoToRowSetting;
  forceOrderInsideStack?: Record<string, PathStringType[]>;
  openPopupSetting?: IOpenPopupSetting;
  closePopupSetting?: IClosePopupSetting;
  addToWishlistSetting?: IAddToWishlistSetting;
  actionPopupSetting?: PopupActionsList;
  endpointActionSetting: IEndpointActionSetting;
}

export type ILinkContent =
  | IGoToPage
  | IGoToRow
  | IChangeOrderInsideStack
  | IOpenPopup
  | IClosePopup
  | IComparison
  | IAddToWishlist
  | IPopupAction
  | IEndpointAction;

export interface IImageContent {
  imageUrl: TUrl;
}

export interface IImageInlineContent {
  imageUrl?: TUrl;
}

export interface IButtonContent {
  link: string | null;
}

export interface IGoToPageSetting {
  link: TUrl | null;
  openInNewTab: boolean;
}

export type TRowId = string | number | null;

export interface IGoToRowSetting {
  rowId: TRowId;
}

export interface IOpenPopupSetting {
  rowId: TRowId;
}

export interface IClosePopupSetting {
  rowId: TRowId;
}

export interface IEndpointActionSetting {
  endpointType: EndpointActionType;
  snackbarSuccessStyle: TSnackbarReadoutValue;
  snackbarErrorStyle: TSnackbarReadoutValue;
}

export enum SelectedGoToOption {
  GO_TO_PAGE = "GO_TO_PAGE",
  GO_TO_ROW = "GO_TO_ROW",
  CHANGE_ORDER_INSIDE_STACK = "CHANGE_ORDER_INSIDE_STACK",
  OPEN_POPUP = "OPEN_POPUP",
  CLOSE_POPUP = "CLOSE_POPUP",
  COMPARISON = "COMPARISON",
  ADD_TO_WISHLIST = "ADD_TO_WISHLIST",
  POPUP_ACTION = "POPUP_ACTION",
  ENDPOINT_ACTION = "ENDPOINT_ACTION",
}

export enum SelectedCategoryOption {
  AD = "AD",
  ONE_PRODUCT = "ONE_PRODUCT",
  TWO_PRODUCTS = "TWO_PRODUCTS",
  FOUR_PRODUCTS = "FOUR_PRODUCTS",
}

export enum PopupActionsList {
  CLOSE_POPUP = "CLOSE_POPUP",
  CONFIRM = "CONFIRM",
}

export enum EndpointActionType {
  NONE = "NONE",
  RESEND_LINK = "RESEND_LINK",
}
